import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import { GreyContainer, LargeWrapper, PopoverHeader } from './SharedStyleComponents';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorIllustration = styled(UIIllustration).withConfig({
  displayName: "ContentAssistantError__ErrorIllustration",
  componentId: "t9adb6-0"
})(["height:70px;margin:8px;"]);
const Heading = styled(H5).withConfig({
  displayName: "ContentAssistantError__Heading",
  componentId: "t9adb6-1"
})(["font-size:14px;margin-bottom:8px;"]);
const Body = styled.p.withConfig({
  displayName: "ContentAssistantError__Body",
  componentId: "t9adb6-2"
})(["font-size:14px;margin-bottom:8px;"]);
const ContentAssistantError = ({
  body,
  label,
  onCancel,
  onTryAgain
}) => {
  return /*#__PURE__*/_jsxs(LargeWrapper, {
    "data-test-id": "error-screen",
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      label: label,
      body: body,
      onCancel: onCancel
    }), /*#__PURE__*/_jsx(ErrorIllustration, {
      name: "errors/general"
    }), /*#__PURE__*/_jsx(Heading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.heading"
      })
    }), /*#__PURE__*/_jsx(Body, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.body"
      })
    }), /*#__PURE__*/_jsx(GreyContainer, {
      hideNavigation: true,
      children: /*#__PURE__*/_jsx(UIButton, {
        size: "small",
        use: "tertiary",
        onClick: onTryAgain,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentAssistantError.tryAgain"
        })
      })
    })]
  });
};
export default ContentAssistantError;